import actionTypes from './actions/actionTypes'

const {
  SHOW_WEBCAM,
  SHOW_UPLOAD,
  REQUEST_UPDATE_DETAILS,
  RECEIVE_UPDATE_DETAILS,
  USER_UPDATED,
  EMAIL_CHANGE,
  CLOSE_SNACKBAR,
  EMAIL_ALREADY_GOT,
  EMAIL_ALREADY_GOT_DISABLE
} = actionTypes

const settingsReducer = (state = {
  isFetchingUserDetails: false,
  showWebcam: false,
  showUploadOtion: false,
  updated: false,
  emailChange: false,
  emailAlreadyGot: false,
  forceUpdate: Math.floor(Math.random() * 1000)
}, action) => {
  switch (action.type) {
    case SHOW_WEBCAM:
      return Object.assign({}, state, {
        showWebcam: action.showWebcam
      })
    case SHOW_UPLOAD:
      return Object.assign({}, state, {
        showUploadOtion: action.showUploadOtion
      })
    case REQUEST_UPDATE_DETAILS:
      return Object.assign({}, state, {
        isFetchingUserDetails: true
      })
    case RECEIVE_UPDATE_DETAILS:
      return Object.assign({}, state, {
        isFetchingUserDetails: false
      })
    case USER_UPDATED:
      return Object.assign({}, state, {
        updated: action.userUpdated
      })
    case EMAIL_CHANGE:
      return Object.assign({}, state, {
        emailChange: true,
        forceUpdate: Math.floor(Math.random() * 1000)
      })
    case CLOSE_SNACKBAR:
      return Object.assign({}, state, {
        emailChange: false,
        forceUpdate: Math.floor(Math.random() * 1000)
      })
    case EMAIL_ALREADY_GOT:
      return Object.assign({}, state, {
        emailAlreadyGot: true,
        forceUpdate: Math.floor(Math.random() * 1000)
      })
    case EMAIL_ALREADY_GOT_DISABLE:
      return Object.assign({}, state, {
        emailAlreadyGot: false,
        forceUpdate: Math.floor(Math.random() * 1000)
      })
    default:
      return state
  }
}

export default settingsReducer



// WEBPACK FOOTER //
// ./src/routes/Settings/reducer.js